import React from "react";
import AboutUI from "./AboutUI";

const About = () => {
  return <AboutUI />;
};

export default About;
